import logo from "../../assets/credit-acceptance-caps-logo.png";
import { formatUserDisplayName } from "../../lib/auth/formatUserDisplayName";
import DealerSetup from "./DealerSetup";
import HelpMenu from "./HelpMenu";

type TopBarProperties = {
  userName?: string;
  userRole?: string;
  onSignOut?: () => void;
};

function TopBar({ userName, userRole, onSignOut }: TopBarProperties) {
  const displayName = formatUserDisplayName(userName, userRole);

  return (
    <header
      data-testid="topbar"
      className="border-border bg-card flex w-full items-center justify-between gap-3 border-b px-4 py-2 sm:px-6 sm:py-2.5"
    >
      <img src={logo} alt="Credit Acceptance | caps" className="h-6 w-auto object-contain sm:h-7" />
      {/* Gate on both userName and onSignOut: while auth is loading user is undefined, hiding the block until identity is confirmed. */}
      <div className="gap-(--spacing-3) [&>*+*]:border-border [&>*+*]:pl-(--spacing-3) flex items-center sm:[&>*+*]:border-l">
        {userName && onSignOut && <span className="hidden sm:inline">{displayName}</span>}
        <HelpMenu />
        <DealerSetup />
        {userName && onSignOut && (
          <button
            type="button"
            onClick={onSignOut}
            className="hover:text-primary cursor-pointer transition-colors hover:underline"
          >
            Sign out
          </button>
        )}
      </div>
    </header>
  );
}

export default TopBar;
